import React, { useEffect, useState } from "react";
import ic_cubix_ribbon_logo from "../img/ic_cubix_ribbon_label.png";
import ic_blue_cube from "../img/ic_blue_cube.png";
import ic_search from "../img/ic_search.png";
import "../css/CheckStockPage.css";
import Header from "./Header";
import axios from "axios";

function CheckStockPage() {

    const [showLoadingStateViewLog, setShowLoadingStateViewLog] = useState(false);
    let timeInterval = null;
    const [selectedItemIndex, setSelectedItemIndex] = useState(null);
    const [showHideSearchListBox, setShowHideSearchListBox] = useState(false);
    const [arrayOfSearchResults, setArrayOfSearchResults] = useState();

    const handleInput = (e) => {

        clearInterval(timeInterval);

        timeInterval = setTimeout(() => {
            if (e.target.value.length > 0) {

                console.log(" searchtext changed is", e.target.value);
                if (timeInterval) {
                    console.log("timer is not null we are clearing it")
                    clearInterval(timeInterval);
                }
                setShowHideSearchListBox(true);
                callApi(e.target.value);

            } else {
                setShowHideSearchListBox(false);
            }
        }, 500)

    }

    const showLoadingForViewLog = () => {
        setShowLoadingStateViewLog(prev => !prev);
    }

    const callApi = (searchingText) => {

        showLoadingForViewLog();

        let privateKeyToSendToAPI = localStorage.getItem("cubix_order_taking_private_key");

        if (privateKeyToSendToAPI == null) {
            privateKeyToSendToAPI = "no_key"
        }
        axios.get(`${process.env.REACT_APP_BASE_URL}/Search_Items/Sitem/${searchingText}?private_key=${privateKeyToSendToAPI}`).then((res) => {
            showLoadingForViewLog();
            console.log(" res is ", res);
            setArrayOfSearchResults(res.data.result)
        }).catch(err => {
            console.log("error is ", err);
            showLoadingForViewLog();
        })
    }

    const clickedItemFromSearchList = (ind) => {
        console.log("clicked on ", ind);
        setSelectedItemIndex(ind)
        setShowHideSearchListBox(false);
    }

    return (
        <div className="CheckStockPage-root-container">

            <div className="CheckStockPage-layer-1">
                <img src={ic_blue_cube} />
            </div>

            <div className="CheckStockPage-layer-2 ">
                <Header />

                <h4>Check Stock</h4>
                <div className="CheckStockPage-layer-2-underline"></div>

                <div className="CheckStockPage-search-box-and-list-container">
                    <div className="CheckStockPage-search-box-container">
                        <div>
                            <img src={ic_search} />
                        </div>
                        <input autoComplete="off" className="CheckStockPage-search-input" type="text" placeholder="Enter item name" name="searchText" onChange={(e) => handleInput(e)} />
                    </div>
                    {showHideSearchListBox &&
                        <div className="CheckStockPage_SearchResultListContainer">

                            <div>
                                {showLoadingStateViewLog ? <p className="loading-table-CustomerDetailPage">Loading</p> : null}
                            </div>

                            <table className="CheckStockPage_SearchResultListContainer-table">
                                <thead>
                                    <tr>
                                        <th>Code</th>
                                        <th>Description</th>
                                        <th>Qty</th>
                                        {
                                            localStorage.getItem("cubix_order_taking_logged_in_person_group").trim() == "WORKER" ? null :
                                                <th>Price</th>
                                        }
                                    </tr>
                                </thead>
                                <tbody>

                                    {arrayOfSearchResults != null ?
                                        arrayOfSearchResults.length > 0 ?
                                            arrayOfSearchResults.map((item, index) => {
                                                return (<tr key={item.Code} id={item.Code} className="CheckStockPage_SearchResultListContainer_single_list_item" onClick={() => clickedItemFromSearchList(index)} >
                                                    <td>
                                                        <div>
                                                            {item.Code}
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="MakeOrderPageListContainer-barcode-container">
                                                            {item.Description}

                                                            {
                                                                (item.Barcode == "0" || item.Barcode.length == 0) ?
                                                                    null
                                                                    :
                                                                    <span className="mt-2">
                                                                        <label className="MakeOrderPageListContainer-barcode-label me-2">Barcode </label>
                                                                        <label className="MakeOrderPageListContainer-barcode-value">{item.Barcode}</label>
                                                                    </span>

                                                            }
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div>
                                                            {item.Qty}
                                                        </div>
                                                    </td>

                                                    {
                                                        localStorage.getItem("cubix_order_taking_logged_in_person_group").trim() == "WORKER" ? null :
                                                            <td>
                                                                <div>
                                                                    {item.price}
                                                                </div>
                                                            </td>

                                                    }

                                                </tr>)
                                            })
                                            : null
                                        : null}

                                </tbody>
                            </table>
                        </div>
                    }
                </div>

                {
                    arrayOfSearchResults ?
                        selectedItemIndex !== null ?
                            arrayOfSearchResults[selectedItemIndex] != null ?
                                <div className="CheckStockPage_details_card">
                                    <label className="mt-2">Item name</label>
                                    <div className="mt-1"><span>{arrayOfSearchResults[selectedItemIndex].Code}</span></div>
                                    <label className="mt-3">Description</label>
                                    <div className="mt-1"><span>{arrayOfSearchResults[selectedItemIndex].Description}</span></div>
                                    <label className="mt-3">Price</label>
                                    <div className="mt-1"><span>{arrayOfSearchResults[selectedItemIndex].price}</span></div>
                                    <label className="mt-3">Quantity</label>
                                    <div className="mt-1"><span>{arrayOfSearchResults[selectedItemIndex].Qty}</span></div>
                                    <label className="mt-3">Barcode</label>
                                    {
                                        (arrayOfSearchResults[selectedItemIndex].Barcode == "0" || arrayOfSearchResults[selectedItemIndex].Barcode.length == 0) ?
                                            <p>No barcode found</p>
                                            :
                                            <div className="mt-1">
                                                <span>{arrayOfSearchResults[selectedItemIndex].Barcode}</span>
                                            </div>

                                    }

                                </div>
                                :
                                null
                            :
                            null

                        :
                        null
                }


            </div>

        </div>
    )

}

export default CheckStockPage;